/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Devices_Revoke_Loading_DescriptionInputs */

const es_user_profile_devices_revoke_loading_description = /** @type {(inputs: User_Profile_Devices_Revoke_Loading_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrando sesión del dispositivo…`)
};

const en_user_profile_devices_revoke_loading_description = /** @type {(inputs: User_Profile_Devices_Revoke_Loading_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing out the device…`)
};

/**
* | output |
* | --- |
* | "Signing out the device…" |
*
* @param {User_Profile_Devices_Revoke_Loading_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_devices_revoke_loading_description = /** @type {((inputs?: User_Profile_Devices_Revoke_Loading_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Devices_Revoke_Loading_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_devices_revoke_loading_description(inputs)
	return en_user_profile_devices_revoke_loading_description(inputs)
});
export { user_profile_devices_revoke_loading_description as "user.profile.devices.revoke.loading_description" }